//Archivo dedicado al menu de todos los imports de Dias Habiles

//Imports relacionados de Dias Habiles
//-----------Principal-----------
import Plantilla from '@/components/DiasHabiles/Comun/Plantilla.vue';

//-----------Consulta de días hábiles -----------
//import Consultas from '@/components/TemisCivil/OficialiaDePartes/Recepcion.vue';
import Consultas from '@/components/DiasHabiles/Consultas/DiasHabiles.vue';


//Se crea la lista de paths
const DiasHabiles = [
  {
    path: '/DiasHabiles/', component: Plantilla, children:[
      { path: 'Consulta', component: Consultas }
    ]
  }
];

//Se regresa la lista de paths
export default DiasHabiles;



// WEBPACK FOOTER //
// ./src/router/DiasHabiles.js